/* import __COLOCATED_TEMPLATE__ from './type-filter.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';

interface Signature {
  Args: {
    reasonTypes: string[];
    onReasonChange: (value: string) => void;
  };
}

export default class TypeFilter extends Component<Signature> {
  @service declare intl: IntlService;

  get isAllReasonsSelected(): boolean {
    return this.args.reasonTypes.length === 0;
  }

  get reasonLabel(): string {
    if (this.args.reasonTypes.length === 0) {
      return this.intl.t('components.reporting.automation.optimize-suggestions.filter.reason.all');
    }
    if (this.args.reasonTypes.length === 1) {
      switch (this.args.reasonTypes[0]) {
        case 'content-gap':
          return this.intl.t(
            'components.reporting.automation.optimize-suggestions.filter.reason.content-gap',
          );
        case 'data-gap':
          return this.intl.t(
            'components.reporting.automation.optimize-suggestions.filter.reason.data-gap',
          );
        case 'action-gap':
          return this.intl.t(
            'components.reporting.automation.optimize-suggestions.filter.reason.action-gap',
          );
      }
    }
    // Multiple selections
    return this.intl.t('components.reporting.automation.optimize-suggestions.filter.selected', {
      count: this.args.reasonTypes.length,
    });
  }

  @action
  handleReasonChange(value: string): void {
    this.args.onReasonChange(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::Filters::TypeFilter': typeof TypeFilter;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/filters/type-filter': typeof TypeFilter;
  }
}
